import { Link } from 'react-router-dom';

export default function ServiceArea() {
  const communes = [
    { name: 'Lyon', url: '/' },
    { name: 'Villeurbanne', url: '/reparation-fenetre-villeurbanne' },
    { name: 'Vénissieux', url: '/reparation-fenetre-venissieux' },
    { name: 'Caluire-et-Cuire', url: '/reparation-fenetre-caluire-et-cuire' },
    { name: 'Saint-Priest', url: '/reparation-fenetre-saint-priest' },
    { name: 'Vaulx-en-Velin', url: '/reparation-fenetre-vaulx-en-velin' },
    { name: 'Bron', url: '/reparation-fenetre-bron' },
    { name: 'Rillieux-la-Pape', url: '/reparation-fenetre-rillieux-la-pape' },
    { name: 'Meyzieu', url: '/reparation-fenetre-meyzieu' },
    { name: 'Décines-Charpieu', url: '/reparation-fenetre-decines-charpieu' },
    { name: 'Oullins', url: '/reparation-fenetre-oullins' },
    { name: 'Sainte-Foy-lès-Lyon', url: '/reparation-fenetre-sainte-foy-les-lyon' },
    { name: 'Tassin-la-Demi-Lune', url: '/reparation-fenetre-tassin-la-demi-lune' },
    { name: 'Écully', url: '/reparation-fenetre-ecully' },
    { name: 'Francheville', url: '/reparation-fenetre-francheville' },
    { name: 'Givors', url: '/reparation-fenetre-givors' },
    { name: 'Genas', url: '/reparation-fenetre-genas' },
    { name: 'Mions', url: '/reparation-fenetre-mions' },
    { name: 'Corbas', url: '/reparation-fenetre-corbas' },
    { name: 'Feyzin', url: '/reparation-fenetre-feyzin' },
    { name: 'Saint-Genis-Laval', url: '/reparation-fenetre-saint-genis-laval' },
    { name: 'Brignais', url: '/reparation-fenetre-brignais' },
    { name: 'Grigny', url: '/reparation-fenetre-grigny' },
    { name: 'Irigny', url: '/reparation-fenetre-irigny' },
    { name: 'Pierre-Bénite', url: '/reparation-fenetre-pierre-benite' },
    { name: 'Charbonnières-les-Bains', url: '/reparation-fenetre-charbonnieres-les-bains' },
    { name: 'Dardilly', url: '/reparation-fenetre-dardilly' },
    { name: 'Limonest', url: '/reparation-fenetre-limonest' },
    { name: 'Champagne-au-Mont-d\'Or', url: '/reparation-fenetre-champagne-au-mont-d-or' },
    { name: 'Saint-Didier-au-Mont-d\'Or', url: '/reparation-fenetre-saint-didier-au-mont-d-or' },
    { name: 'Collonges-au-Mont-d\'Or', url: '/reparation-fenetre-collonges-au-mont-d-or' },
    { name: 'Fontaines-sur-Saône', url: '/reparation-fenetre-fontaines-sur-saone' },
    { name: 'Sathonay-Camp', url: '/reparation-fenetre-sathonay-camp' },
    { name: 'Sathonay-Village', url: '/reparation-fenetre-sathonay-village' },
    { name: 'Neuville-sur-Saône', url: '/reparation-fenetre-neuville-sur-saone' },
    { name: 'Rochetaillée-sur-Saône', url: '/reparation-fenetre-rochetaillee-sur-saone' },
    { name: 'Albigny-sur-Saône', url: '/reparation-fenetre-albigny-sur-saone' },
    { name: 'Couzon-au-Mont-d\'Or', url: '/reparation-fenetre-couzon-au-mont-d-or' },
    { name: 'Saint-Romain-au-Mont-d\'Or', url: '/reparation-fenetre-saint-romain-au-mont-d-or' },
    { name: 'Poleymieux-au-Mont-d\'Or', url: '/reparation-fenetre-poleymieux-au-mont-d-or' },
    { name: 'Saint-Cyr-au-Mont-d\'Or', url: '/reparation-fenetre-saint-cyr-au-mont-d-or' },
    { name: 'Curis-au-Mont-d\'Or', url: '/reparation-fenetre-curis-au-mont-d-or' },
    { name: 'Saint-Fons', url: '/reparation-fenetre-saint-fons' },
    { name: 'Solaize', url: '/reparation-fenetre-solaize' },
    { name: 'Vernaison', url: '/reparation-fenetre-vernaison' },
    { name: 'Mornant', url: '/reparation-fenetre-mornant' },
    { name: 'Chaponost', url: '/reparation-fenetre-chaponost' },
    { name: 'Craponne', url: '/reparation-fenetre-craponne' },
    { name: 'Chassieu', url: '/reparation-fenetre-chassieu' },
    { name: 'Villefranche-sur-Saône', url: '/reparation-fenetre-villefranche-sur-saone' },
    { name: 'Belleville-en-Beaujolais', url: '/reparation-fenetre-belleville-en-beaujolais' },
    { name: 'Tarare', url: '/reparation-fenetre-tarare' },
    { name: 'L\'Arbresle', url: '/reparation-fenetre-l-arbresle' },
    { name: 'Anse', url: '/reparation-fenetre-anse' },
    { name: 'Millery', url: '/reparation-fenetre-millery' },
    { name: 'Saint-Laurent-de-Mure', url: '/reparation-fenetre-saint-laurent-de-mure' },
    { name: 'Saint-Symphorien-sur-Coise', url: '/reparation-fenetre-saint-symphorien-sur-coise' }
  ];

  // Communes sans lien (à venir)
  const communesAVenir = [
    'Fontaines-Saint-Martin', 'Genay', 'Montanay', 'Cailloux-sur-Fontaines', 
    'Fleurieu-sur-Saône', 'La Mulatière', 'Charly', 'Ternay', 
    'Orliénas', 'Taluyers', 'Montagny', 'Soucieu-en-Jarrest', 'Messimy', 
    'Vourles', 'Marcy-l\'Étoile', 'La Tour-de-Salvagny', 'Lentilly', 
    'Dommartin', 'Pollionnay', 'Sainte-Consorce', 'Grézieu-la-Varenne', 
    'Vaugneray', 'Yzeron', 'Thurins', 'Riverie', 'Rontalon', 
    'Saint-Laurent-d\'Agny', 'Saint-Symphorien-d\'Ozon', 'Simandres', 
    'Communay', 'Sérézin-du-Rhône', 'Saint-Bonnet-de-Mure', 
    'Colombier-Saugnieu', 'Jons', 'Pusignan', 'Jonage', 'Neyron', 
    'Miribel', 'Thil', 'Tramoyes', 'Beynost', 'Dagneux', 'Montluel', 
    'La Boisse', 'Niévroz', 'Saint-Maurice-de-Beynost', 'Rillieux', 
    'Crépieux-la-Pape', 'Sathonay', 'Vancia', 'Parcieux', 'Massieux', 
    'Reyrieux', 'Trévoux', 'Saint-Didier-de-Formans', 'Frans', 
    'Lachassagne', 'Lucenay', 'Morancé', 'Pommiers', 'Gleizé', 'Arnas', 
    'Limas', 'Jassans-Riottier', 'Sain-Bel', 'Sourcieux-les-Mines', 
    'Savigny', 'Brindas', 'Chabanière', 'Chevinay', 'Saint-Pierre-la-Palud', 
    'Bessenay', 'Bibost', 'Fleurieux-sur-l\'Arbresle', 'Lozanne', 
    'Civrieux-d\'Azergues', 'Chazay-d\'Azergues', 'Lissieu', 'Chasselay', 
    'Saint-Germain-au-Mont-d\'Or', 'Poleymieux', 'Quincieux', 'Fareins', 
    'Beauregard', 'Ambérieux-d\'Azergues', 'Chessy', 'Liergues', 
    'Porte-des-Pierres-Dorées', 'Theizé', 'Moiré', 'Cogny', 
    'Saint-Jean-des-Vignes', 'Salles-Arbuissonnas', 'Vaux-en-Beaujolais', 
    'Rivolet', 'Blacé', 'Denicé', 'Odenas', 'Saint-Lager', 'Cercié', 
    'Charentay', 'Marchampt', 'Ville-sur-Jarnioux', 'Jarnioux', 'Ternand', 
    'Légny', 'Alix', 'Bagnols', 'Frontenas', 'Marcy', 'Oingt', 
    'Saint-Laurent-d\'Oingt', 'Chamelet', 'Les Chères', 'Chessy-les-Mines', 
    'Sainte-Paule', 'Bully', 'Sarcey', 'Montromant', 'Courzieu', 
    'Larajasse', 'Pomeys', 'Duerne', 'Saint-Clément-sur-Valsonne', 'Joux', 
    'Pontcharra-sur-Turdine', 'Saint-Forgeux', 'Ancy', 'Villechenève', 
    'Affoux', 'Chambost-Longessaigne', 'Coise', 'Haute-Rivoire', 
    'Longessaigne', 'Sainte-Foy-l\'Argentière', 'Saint-Julien-sur-Bibost', 
    'Souzy', 'Brussieu', 'Villers-la-Pape', 'Grandris', 
    'Poule-les-Écharmeaux', 'Ranchal', 'Ronno', 'Saint-Bonnet-le-Troncy', 
    'Saint-Clément-de-Vers', 'Saint-Cyr-le-Chatoux', 'Saint-Just-d\'Avray', 
    'Saint-Nizier-d\'Azergues', 'Saint-Vérand', 'Valsonne', 'Amplepuis', 
    'Meaux-la-Montagne', 'Thizy-les-Bourgs', 'Cours', 
    'Lamure-sur-Azergues', 'Cublize', 'Azolette', 'Chambost-Allières'
  ];

  const zones = [
    { name: 'Grand Lyon', count: 59, color: 'from-teal-500 to-teal-600' },
    { name: 'Beaujolais', count: 72, color: 'from-purple-500 to-purple-600' },
    { name: 'Monts du Lyonnais', count: 45, color: 'from-orange-500 to-orange-600' },
    { name: 'Val de Saône', count: 24, color: 'from-cyan-500 to-cyan-600' }
  ];

  return (
    <section className="relative py-20 lg:py-28 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-50 via-white to-teal-50/30"></div>
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-teal-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-cyan-500 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center space-x-2 bg-teal-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-map-pin-line text-teal-600 text-lg"></i>
            <span className="text-teal-700 font-bold text-sm uppercase tracking-wider">
              Zone d'Intervention
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4">
            Tout le Rhône <span className="text-teal-600">(69)</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Plus de 200 communes couvertes pour vos réparations de fenêtres et volets
          </p>
        </div>

        {/* Zones Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {zones.map((zone, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${zone.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300`}></div>
              <div className="relative">
                <div className="flex items-center justify-between mb-4">
                  <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${zone.color} flex items-center justify-center`}>
                    <i className="ri-map-2-fill text-white text-xl"></i>
                  </div>
                  <div className="text-right">
                    <div className="text-3xl font-extrabold text-gray-900">{zone.count}</div>
                    <div className="text-xs text-gray-500">communes</div>
                  </div>
                </div>
                <h3 className="text-lg font-bold text-gray-900 group-hover:text-teal-600 transition-colors">
                  {zone.name}
                </h3>
              </div>
            </div>
          ))}
        </div>

        {/* Map Section */}
        <div className="grid lg:grid-cols-3 gap-8 mb-12">
          {/* Map */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden h-[500px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d357555.5357174!2d4.5419!3d45.7640!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f4ea516ae88797%3A0x408ab2ae4bb21f0!2sRh%C3%B4ne%2C%20France!5e0!3m2!1sfr!2sfr!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Carte du Rhône"
              ></iframe>
            </div>
          </div>

          {/* Stats & Info */}
          <div className="space-y-6">
            <div className="bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl p-8 text-white shadow-xl">
              <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center mb-4">
                <i className="ri-shield-check-fill text-white text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold mb-2">Service Garanti</h3>
              <p className="text-white/90 text-sm mb-6">
                Intervention rapide dans tout le département du Rhône
              </p>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center">
                    <i className="ri-time-line text-white text-lg"></i>
                  </div>
                  <div>
                    <div className="font-bold text-lg">24h</div>
                    <div className="text-xs text-white/80">Délai d'intervention</div>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center">
                    <i className="ri-car-line text-white text-lg"></i>
                  </div>
                  <div>
                    <div className="font-bold text-lg">0€</div>
                    <div className="text-xs text-white/80">Frais de déplacement</div>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center">
                    <i className="ri-phone-line text-white text-lg"></i>
                  </div>
                  <div>
                    <div className="font-bold text-lg">7j/7</div>
                    <div className="text-xs text-white/80">Disponibilité</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <h4 className="font-bold text-gray-900 mb-4 flex items-center">
                <i className="ri-question-line text-teal-600 mr-2"></i>
                Besoin d'un devis ?
              </h4>
              <p className="text-gray-600 text-sm mb-4">
                Contactez-nous pour une intervention rapide dans votre commune
              </p>
              <a
                href="#contact"
                className="block w-full bg-gradient-to-r from-teal-500 to-cyan-500 text-white text-center px-6 py-3 rounded-xl font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
              >
                Demander un Devis
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Communes List - Accordion Style */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="bg-gradient-to-r from-teal-500 to-cyan-500 px-8 py-6">
            <div className="flex items-center justify-between text-white">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 rounded-xl bg-white/20 flex items-center justify-center">
                  <i className="ri-building-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold">Toutes nos Communes</h3>
                  <p className="text-white/90 text-sm">200+ villes et villages du Rhône</p>
                </div>
              </div>
              <div className="text-right">
                <div className="text-4xl font-extrabold">200+</div>
                <div className="text-sm text-white/80">Communes</div>
              </div>
            </div>
          </div>

          <div className="hidden md:block p-6">
            {/* Communes avec pages dédiées */}
            <div className="mb-8">
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-8 h-8 rounded-lg bg-teal-500 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-white text-lg"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900">
                  Communes avec page dédiée
                  <span className="ml-2 text-sm font-normal text-teal-600">({communes.length} communes)</span>
                </h4>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-2">
                {communes.map((commune, index) => (
                  <Link
                    key={index}
                    to={commune.url}
                    className="group flex items-center space-x-2 bg-teal-50 hover:bg-gradient-to-r hover:from-teal-100 hover:to-cyan-100 px-3 py-2 rounded-lg transition-all duration-300 cursor-pointer border border-teal-200 hover:border-teal-400 hover:shadow-md"
                  >
                    <div className="w-5 h-5 rounded-full bg-teal-500 flex items-center justify-center transition-colors flex-shrink-0">
                      <i className="ri-map-pin-fill text-white text-xs"></i>
                    </div>
                    <span className="text-gray-900 text-xs font-semibold group-hover:text-teal-700 transition-colors truncate">
                      {commune.name}
                    </span>
                  </Link>
                ))}
              </div>
            </div>

            {/* Communes à venir */}
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-8 h-8 rounded-lg bg-gray-400 flex items-center justify-center">
                  <i className="ri-time-line text-white text-lg"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900">
                  Autres communes desservies
                  <span className="ml-2 text-sm font-normal text-gray-600">({communesAVenir.length} communes)</span>
                </h4>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-2">
                {communesAVenir.map((commune, index) => (
                  <div
                    key={index}
                    className="group flex items-center space-x-2 bg-gray-50 hover:bg-gray-100 px-3 py-2 rounded-lg transition-all duration-300 cursor-default border border-gray-200"
                  >
                    <div className="w-5 h-5 rounded-full bg-gray-300 flex items-center justify-center transition-colors flex-shrink-0">
                      <i className="ri-map-pin-line text-gray-600 text-xs"></i>
                    </div>
                    <span className="text-gray-600 text-xs font-medium truncate">
                      {commune}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center space-x-4 bg-gray-900 px-8 py-5 rounded-2xl shadow-2xl">
            <div className="w-14 h-14 rounded-full bg-teal-500 flex items-center justify-center">
              <i className="ri-customer-service-2-fill text-white text-2xl"></i>
            </div>
            <div className="text-left">
              <div className="text-white/80 text-sm">Votre commune n'apparaît pas ?</div>
              <div className="text-white text-xl font-bold">Appelez-nous : 09 80 80 36 84</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
